import { render } from "./CandleFormStep1.vue?vue&type=template&id=20a13b75&scoped=true&lang=html"
import script from "./CandleFormStep1.vue?vue&type=script&lang=js"
export * from "./CandleFormStep1.vue?vue&type=script&lang=js"

import "./CandleFormStep1.vue?vue&type=style&index=0&id=20a13b75&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a13b75"]])

export default __exports__